// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportConfigView_pageWrapper__mk5rT {
  display: flex;
  gap: 1rem;
}
@media (max-width: 900px) {
  .ReportConfigView_pageWrapper__mk5rT {
    flex-direction: column;
  }
}

.ReportConfigView_cardWrapper__OPtda {
  flex: 1 1;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
}

.ReportConfigView_datePicker__X4KVO {
  border: 1px solid #f1f1f1;
  padding: 0.5rem;
  border-radius: 4px;
  min-width: 25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/ReportConfigView.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;AACF;AACE;EAJF;IAKI,sBAAA;EAEF;AACF;;AACA;EACE,SAAA;EACA,aAAA;EACA,SAAA;EAEA,4DAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;AACF","sourcesContent":[".pageWrapper {\n  display: flex;\n  gap: 1rem;\n}\n@media (max-width: 900px) {\n  .pageWrapper {\n    flex-direction: column;\n  }\n}\n\n.cardWrapper {\n  flex: 1;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n}\n\n.datePicker {\n  border: 1px solid #f1f1f1;\n  padding: 0.5rem;\n  border-radius: 4px;\n  min-width: 25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-self: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `ReportConfigView_pageWrapper__mk5rT`,
	"cardWrapper": `ReportConfigView_cardWrapper__OPtda`,
	"datePicker": `ReportConfigView_datePicker__X4KVO`
};
export default ___CSS_LOADER_EXPORT___;
